import React from 'react';
import { SvgIcon } from '../../';
function CrossIcon(props) {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 32 32" },
        React.createElement("line", { stroke: "currentColor", strokeWidth: "2px", strokeLinecap: "round", x1: "10", y1: "10", x2: "22", y2: "22" }),
        React.createElement("line", { stroke: "currentColor", strokeWidth: "2px", strokeLinecap: "round", x1: "22", y1: "10", x2: "10", y2: "22" })));
}
export default CrossIcon;
//# sourceMappingURL=CrossIcon.js.map